import { render, staticRenderFns } from "./ViewLinkBI.vue?vue&type=template&id=824fe3fe"
import script from "./ViewLinkBI.vue?vue&type=script&lang=js"
export * from "./ViewLinkBI.vue?vue&type=script&lang=js"
import style0 from "./ViewLinkBI.vue?vue&type=style&index=0&id=824fe3fe&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports